<template>
	<div>
		<div class="row justify-content-center text-center">
			<img  src="../../images/dashboard/logo_shayah.png" height="50%" width="50%" >
		</div>
		<br>
		<div class="row justify-content-center text-center">
			<p class="lead">
				{{ getGreeting() }}, {{ username }}!
			</p>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex';

	export default {
		async beforeRouteEnter(to, from, next) {
			next();
		},

		computed: {
			...mapState({
				stats: state => state.stats.stats,
				username: state => state.auth.self.username,
			})
		},

		methods: {
			getGreeting() {
				var today = new Date();
				var curHr = today.getHours();

				if (curHr < 12) {
					return 'Good morning';
				} else if (curHr < 18) {
					return 'Good afternoon';
				} else {
					return 'Good evening';
				}
			},
		},

		meta: {
			title: 'Dashboard',

			meta: [
				{property: 'og:title', content: 'Dashboard / The Chair'},
			],
		},
	};
</script>